<h1 mat-dialog-title>Table Configuration</h1>

<mat-dialog-content class="mat-typography">
  <div class="container-fluid">
    <form [formGroup]="tableConfigForm">
      <div class="row">
        <!-- <div class="col-md-3">
          <mat-form-field>
            <mat-label class="required-field dark-grey"> Table </mat-label>
            <mat-select formControlName="table" [(ngModel)]="tablen">
              <mat-option
                *ngFor="let table of tableList"
                [value]="table.optionValue"
              >
                {{ table.optionText }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> -->
        <div class="ng-select-container form-group col-md-3">
          <mat-label class="required-field dark-grey ng-select-label">
            Table
          </mat-label>
          <ng-select
            appendTo="body"
            [items]="tableList"
            bindLabel="optionText"
            bindValue="optionValue"
            placeholder="Table"
            [multiple]="false"
            formControlName="table"
            [searchable]="true"
            [(ngModel)]="tablen"
            [selectableGroup]="true"
            [closeOnSelect]="true"
            [selectableGroupAsModel]="true"
          >
          </ng-select>
        </div>
        <div class="col-md-3">
          <mat-form-field>
            <mat-label class="required-field">Sequence Number</mat-label>
            <input
              matInput
              type="text"
              formControlName="sequence"
              maxlength="50"
              [(ngModel)]="sequencen"
            />
          </mat-form-field>
        </div>

        <div class="col-md-3">
          <mat-form-field>
            <mat-label>Where Clause</mat-label>
            <input
              matInput
              type="text"
              formControlName="whereClause"
              [(ngModel)]="whereClauseN"
            />
          </mat-form-field>
        </div>

        <div class="ng-select-container col-md-3">
          <mat-label class="required-field dark-grey ng-select-label">
            Operation
          </mat-label>
          <ng-select
            appendTo="body"
            [items]="operationList"
            bindLabel="optionText"
            placeholder="Eg: Insert/Update"
            [multiple]="false"
            formControlName="operation"
            [searchable]="true"
            [selectableGroup]="true"
            [closeOnSelect]="true"
          >
          </ng-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button
            mat-flat-button
            *ngIf="!isUpdate"
            color="primary"
            (click)="onAdd()"
            [disabled]="!tableConfigForm.valid"
          >
            Add
          </button>
          <button
            mat-flat-button
            *ngIf="isUpdate"
            color="primary"
            (click)="onUpdate()"
          >
            Update
          </button>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-md-12">
          <mat-card class="card" layout-align="center center">
            <mat-card-title> Table List</mat-card-title>

            <dynamic-grid
              #dynamicGrid
              [rows]="rows"
              [cols]="cols"
              [isExternalPaging]="false"
              [isEditable]="true"
              [canAddRow]="false"
              (onActionPerformed)="onActionPerformed($event)"
            ></dynamic-grid>
          </mat-card>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="dg-btn pt-4 px-2 text-end w-100 top-shadow">
    <button mat-flat-button [mat-dialog-close]="false">Cancel</button>
    <button (click)="onReset()" mat-flat-button>Reset</button>

    <button mat-flat-button color="primary" (click)="onSave()">Save</button>
  </div>
</mat-dialog-actions>
